import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { Button } from "react-bootstrap";
import { convertStraight, formatDateTimezon } from "../common-data/Converts";
import ApproveRejectForm from "./ApproveRejectForm";
import { fetchTMEApprovalManagerData } from "../../redux/prospect-reducers/prospectSlice";
import { CheckCircleIcon, CrossCircleIcon } from "../../images/icons/icons";

const MemberConsultationData = ({
  rowData,
  userInfoData,
  callFunction,
  onCloseModal,
}) => {
  const dispatch = useDispatch();
  const {
    tmeApprovalManagerLoading,
    tmeApprovalManager,
    tmeApprovalManagerError,
  } = useSelector((state) => state.prospects);

  // const isAdmin = userInfoData?.account_type === "admin";

  const [isApprovalManager, setIsApprovalManager] = useState(false);

  const {
    user_name,
    gender,
    exercise_freq,
    fitness_goal,
    consultation_focus_on,
    exercise_type,
    fitness_experience,
    worked_with_pt_trainer,
    free_pt_consultation,
    pt_schedule_date,
    pt_experience,
    medical_history,
    physical_limitation,
    no_pt_consult_reason,
    description,
    approval_required,
    is_approved,
    aprv_rej_date,
    aprv_rej_by_name,
    aprv_rej_by_mobile,
    aprv_rej_by_email,
    aprv_rej_description,
    bca_report,
    prog_pics,
  } = rowData || {};

  const iniClickValues = {
    isModOpen: false,
    rowData: "",
    cardName: "",
  };
  const [clickValues, setClickValues] = useState(iniClickValues);

  function onCloseModal1() {
    setClickValues(iniClickValues);
  }

  function getApprovalManagers(filters) {
    dispatch(
      fetchTMEApprovalManagerData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    if (userInfoData?.uid || userInfoData?.user_id) {
      const filters = {
        user_id: userInfoData?.uid || userInfoData?.user_id || "",
      };

      getApprovalManagers(filters);
    }
  }, []);

  useEffect(() => {
    if (
      !tmeApprovalManagerLoading &&
      !tmeApprovalManagerError &&
      tmeApprovalManager?.data?.length > 0
    ) {
      setIsApprovalManager(true);
    } else {
      setIsApprovalManager(false);
    }
  }, [tmeApprovalManagerLoading, tmeApprovalManagerError, tmeApprovalManager]);

  return (
    <>
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <ApproveRejectForm
          rowData={clickValues.rowData}
          userInfoData={userInfoData}
          closeModal={() => {
            onCloseModal();
            onCloseModal1();
          }}
          callFunction={callFunction}
          cardName={clickValues.cardName}
        />
      </Modal>

      <div className="mini-tb-container mt30">
        <ul className="tb-section tb-section-1">
          <li className="tb-section-item tb-section-item-lable">name</li>
          <li className="tb-section-item tb-section-item-lable">gender</li>
          <li className="tb-section-item tb-section-item-lable">
            exercise duration in a week
          </li>
          <li className="tb-section-item tb-section-item-lable">
            member fitness goals
          </li>
          <li className="tb-section-item tb-section-item-lable">
            consultation focus
          </li>
          <li className="tb-section-item tb-section-item-lable">
            exercise types
          </li>
          <li className="tb-section-item tb-section-item-lable">
            member fitness experience
          </li>
          <li className="tb-section-item tb-section-item-lable">
            Previous PT experience
          </li>
          <li className="tb-section-item tb-section-item-lable">
            interested for PT trial
          </li>
          <li className="tb-section-item tb-section-item-lable">
            PT Trial date
          </li>
          <li className="tb-section-item tb-section-item-lable">
            previous PT experience
          </li>
          <li className="tb-section-item tb-section-item-lable">
            medical history
          </li>
          <li className="tb-section-item tb-section-item-lable">
            physical limitation
          </li>
          {!free_pt_consultation && (
            <li className="tb-section-item tb-section-item-lable">
              Non PT Reason
            </li>
          )}
          <li className="tb-section-item tb-section-item-lable">remarks</li>
          <li className="tb-section-item tb-section-item-lable">
            engagement approval required
          </li>
          {approval_required ? (
            <li className="tb-section-item tb-section-item-lable">
              engagement approval status
            </li>
          ) : null}
          {approval_required && (is_approved === 1 || is_approved === 2) ? (
            <>
              <li className="tb-section-item tb-section-item-lable">
                engagement {is_approved === 1 ? "approve" : "reject"} date
              </li>
              <li className="tb-section-item tb-section-item-lable">
                engagement {is_approved === 1 ? "approved" : "rejected"} by
              </li>
              <li className="tb-section-item tb-section-item-lable dependent-div">
                engagement {is_approved === 1 ? "approve" : "reject"} remarks
              </li>
            </>
          ) : approval_required && is_approved === 0 && isApprovalManager ? (
            <li className="tb-section-item tb-section-item-lable">
              approve/reject engagement request
            </li>
          ) : null}
          <li className="tb-section-item tb-section-item-lable">BCA Report</li>
          <li className="tb-section-item tb-section-item-lable images">
            Transformation Images
          </li>
        </ul>

        <ul className="tb-section tb-section-2">
          <li className="tb-section-item tb-section-item-lable-value">
            {user_name || "NA"}
          </li>
          <li className="tb-section-item tb-section-item-lable-value">
            {gender || "NA"}
          </li>
          <li className="tb-section-item tb-section-item-lable-value">
            {exercise_freq?.replace(/_/g, " ") || "NA"}
          </li>
          <li className="tb-section-item tb-section-item-lable-value">
            {fitness_goal?.replace(/_/g, " ") || "NA"}
          </li>
          <li className="tb-section-item tb-section-item-lable-value">
            {consultation_focus_on?.replace(/_/g, " ") || "NA"}
          </li>
          <li className="tb-section-item tb-section-item-lable-value">
            {exercise_type?.replace(/_/g, " ") || "NA"}
          </li>
          <li className="tb-section-item tb-section-item-lable-value">
            {fitness_experience?.replace(/_/g, " ") || "NA"}
          </li>
          <li className="tb-section-item tb-section-item-lable-value tb-section-item-lable-icon">
            {worked_with_pt_trainer ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </li>
          <li className="tb-section-item tb-section-item-lable-value tb-section-item-lable-icon">
            {free_pt_consultation ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </li>
          <li className="tb-section-item tb-section-item-lable-value">
            {pt_schedule_date ? convertStraight(pt_schedule_date) : "-"}
          </li>
          <li className="tb-section-item tb-section-item-lable-value">
            {pt_experience || "NA"}
          </li>
          <li className="tb-section-item tb-section-item-lable-value">
            {medical_history || "NA"}
          </li>
          <li className="tb-section-item tb-section-item-lable-value">
            {physical_limitation || "NA"}
          </li>
          {!free_pt_consultation && (
            <li className="tb-section-item tb-section-item-lable-value">
              {no_pt_consult_reason || "NA"}
            </li>
          )}
          <li className="tb-section-item tb-section-item-lable-value">
            {description || "NA"}
          </li>
          <li className="tb-section-item tb-section-item-lable-value tb-section-item-lable-icon">
            {approval_required ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </li>
          {approval_required ? (
            <li className="tb-section-item tb-section-item-lable-value tb-section-item-lable-icon">
              {is_approved === 1 ? (
                <CheckCircleIcon />
              ) : is_approved === 2 ? (
                <CrossCircleIcon />
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-hourglass-top"
                  viewBox="0 0 16 16"
                  style={{ color: "#EB5B00" }}
                >
                  <path d="M2 14.5a.5.5 0 0 0 .5.5h11a.5.5 0 1 0 0-1h-1v-1a4.5 4.5 0 0 0-2.557-4.06c-.29-.139-.443-.377-.443-.59v-.7c0-.213.154-.451.443-.59A4.5 4.5 0 0 0 12.5 3V2h1a.5.5 0 0 0 0-1h-11a.5.5 0 0 0 0 1h1v1a4.5 4.5 0 0 0 2.557 4.06c.29.139.443.377.443.59v.7c0 .213-.154.451-.443.59A4.5 4.5 0 0 0 3.5 13v1h-1a.5.5 0 0 0-.5.5m2.5-.5v-1a3.5 3.5 0 0 1 1.989-3.158c.533-.256 1.011-.79 1.011-1.491v-.702s.18.101.5.101.5-.1.5-.1v.7c0 .701.478 1.236 1.011 1.492A3.5 3.5 0 0 1 11.5 13v1z" />
                </svg>
              )}
            </li>
          ) : null}
          {approval_required && (is_approved === 1 || is_approved === 2) ? (
            <>
              <li className="tb-section-item tb-section-item-lable-value">
                {aprv_rej_date ? formatDateTimezon(aprv_rej_date) : "-"}
              </li>
              <li className="tb-section-item tb-section-item-lable-value">
                {aprv_rej_by_name || "NA"} (
                <small className="lowercase">
                  {aprv_rej_by_mobile || ""}/{aprv_rej_by_email || ""}
                </small>
                )
              </li>
              <li className="tb-section-item tb-section-item-lable-value reference-div">
                {aprv_rej_description || ""}
              </li>
            </>
          ) : approval_required && is_approved === 0 && isApprovalManager ? (
            <li className="tb-section-item tb-section-item-lable-value tb-section-item-lable-btns">
              <Button
                type="button"
                variant="primary"
                onClick={() =>
                  setClickValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    rowData: rowData,
                    cardName: "approve",
                  }))
                }
              >
                approve
              </Button>
              <Button
                type="button"
                variant="danger"
                onClick={() =>
                  setClickValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    rowData: rowData,
                    cardName: "reject",
                  }))
                }
              >
                reject
              </Button>
            </li>
          ) : null}
          <li className="tb-section-item tb-section-item-lable-value tb-section-item-lable-icon">
            {bca_report ? (
              <a href={bca_report}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-cloud-arrow-down"
                  viewBox="0 0 16 16"
                  style={{
                    color: "#209216",
                    minWidth: "35px",
                    minHeight: "35px",
                  }}
                >
                  <path
                    fillRule="evenodd"
                    d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708z"
                  />
                  <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                </svg>
              </a>
            ) : (
              <CrossCircleIcon />
            )}
          </li>
          <li className="tb-section-item tb-section-item-lable-value images">
            {prog_pics?.length > 0 &&
              prog_pics.map((img, index) => (
                <img src={img} alt={user_name} key={index} />
              ))}
          </li>
        </ul>
      </div>
    </>
  );
};

export default MemberConsultationData;
